import {
  ARTICLES
} from '../constants/types';

export default function(state=[], action){
  switch(action.type){
    case ARTICLES:
      return action.payload
    default:
      return state
  }
}
